import { useEffect, useState } from "react";
import { api } from "@/api/client";

export type BonusTruth = {
  worldChampion: string | null;
  topScorer: string | null;
  groupWinners: Record<string, string> | null;
  resolvedAt: string | null;
};

/**
 * "Is the Tippspiel over?"
 *
 * The trigger is deliberately `bonusTruth.resolvedAt`, NOT "all games
 * finished": bonus questions are worth up to 125 points and are the LAST
 * thing that moves the standings. Crowning a champion after the final
 * whistle but before the bonus resolution would show the wrong winner —
 * and the prizes (5.000 € group sponsoring + the single main prize) are
 * decided by exactly these final standings.
 */
export function useTournamentFinal() {
  const [truth, setTruth] = useState<BonusTruth | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api.bonus
      .truth()
      .then((t) => { if (alive) setTruth((t as BonusTruth) ?? null); })
      .catch(() => { if (alive) setTruth(null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return { final: !!truth?.resolvedAt, truth, loading };
}
